// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".make-up-order-list[data-v-4145c3f2] {\n  height: 100%;\n}\n.make-up-order-list .muted[data-v-4145c3f2] {\n  color: var(--yq-font-color-desc);\n  font-size: 0.32rem;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
